import React, { useState, useEffect, useMemo } from 'react';

const Img = ({ fallback, src, alt, className, width, height, handleClick }) => {
  const [loading, setLoading] = useState(true);
  const preloadImage = useMemo(() => new Image(width, height), [width, height]);

  useEffect(() => {
    const handleLoading = () => {
      setLoading(false);
    };
    preloadImage.src = src;
    preloadImage.addEventListener('load', handleLoading);

    return () => {
      preloadImage.removeEventListener('load', handleLoading);
    };
  }, [preloadImage, src]);

  return loading ? (
    fallback
  ) : (
    <img
      width={width}
      height={height}
      className={`${className} max-width max-height`}
      loading="lazy"
      decoding="async"
      alt={alt}
      src={preloadImage.src}
      onClick={handleClick ? handleClick : null}
      onContextMenu={e => e.preventDefault()}
    />
  );
};

export default Img;
